<report-grid-wrapper [header]="header" [accountId]="accountId" [type]="GridType.SESSIONS">

	<vb-ui-infinite-scroll-grid [ngClass]="styles.grid" [getRows]="AnalyticsService.getRows" [dataFetchContext]="AnalyticsService.dataFetchContext$ | async" [pageSize]="pageSize">

		<!--Column Picker Groups-->
		<vb-ui-column-picker-group [headerName]="'Video' | translate" [id]="ViewsColumnPickerGroup.VIDEO" [isExpanded]="true">
		</vb-ui-column-picker-group>

		<vb-ui-column-picker-group [headerName]="'User' | translate" [id]="ViewsColumnPickerGroup.USER" [isExpanded]="true">
		</vb-ui-column-picker-group>

		<vb-ui-column-picker-group [headerName]="'Reports_Column_Group_Session' | translate" [id]="ViewsColumnPickerGroup.SESSION" [isExpanded]="true">
		</vb-ui-column-picker-group>

		<vb-ui-column-picker-group [headerName]="'Reports_Column_Group_System' | translate" [id]="ViewsColumnPickerGroup.SYSTEM" [isExpanded]="true">
		</vb-ui-column-picker-group>

		<vb-ui-column-picker-group [headerName]="'Reports_Column_Group_Metrics' | translate" [id]="ViewsColumnPickerGroup.METRICS" [isExpanded]="true" [disableColumnEntrySort]="true">
		</vb-ui-column-picker-group>

		<!--Default Columns-->
		<vb-ui-data-grid-column [columnPickerGroup]="ViewsColumnPickerGroup.SESSION" [field]="'DateViewed'" [headerName]="'Reports_Column_DateViewed' | translate" [sortable]="true" [tooltipField]="'DateViewed'" [valueFormatter]="mediumDateTimeValueFormatter" [filter]="false">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [columnPickerGroup]="ViewsColumnPickerGroup.VIDEO" [field]="'Title'" [headerName]="'Title' | translate" [sortable]="true" [tooltipField]="'Title'" [cellRenderer]="'highlightText'">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.USER" [field]="'FullName'" [headerName]="'Reports_Attendees_Column_FullName' | translate" [sortable]="true" [tooltipField]="'FullName'">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.METRICS" [field]="'IsComplete'" [headerName]="'Reports_Column_Completed' | translate" [sortable]="true" [filter]="false">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.METRICS" [field]="'DropOff'" [headerName]="'Reports_Column_DropOff' | translate" [sortable]="true" [tooltipField]="'DropOff'" [hide]="true" [filter]="false">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.METRICS" [field]="'SessionTime'" [headerName]="'Reports_Attendees_Column_ViewingTime' | translate" [sortable]="true" [tooltipField]="'SessionTime'" [filter]="false">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.METRICS" [field]="'PublicCDNTime'" [headerName]="'Reports_Attendees_Column_PublicCDNTime' | translate" [sortable]="true" [filter]="false">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.METRICS" [field]="'ECDNTime'" [headerName]="'Reports_Attendees_Column_ECDNTime' | translate" [sortable]="true" [filter]="false">
		</vb-ui-data-grid-column>

		<!----------------------------->

		<vb-ui-data-grid-column [columnPickerGroup]="ViewsColumnPickerGroup.VIDEO" [field]="'VideoId'" [headerName]="'VideoId' | translate" [sortable]="true" [cellRenderer]="'highlightText'" [hide]="true">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.USER" [field]="'Username'" [headerName]="'Reports_Attendees_Column_UserName' | translate" [sortable]="true" [tooltipField]="'Username'" [hide]="true">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.USER" [field]="'FirstName'" [headerName]="'FirstName' | translate" [sortable]="true" [tooltipField]="'FirstName'" [hide]="true">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.USER" [field]="'LastName'" [headerName]="'LastName' | translate" [sortable]="true" [tooltipField]="'LastName'" [hide]="true">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.USER" [field]="'Email'" [headerName]="'Reports_Attendees_Column_Email' | translate" [sortable]="true" [tooltipField]="'Email'" [hide]="true">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.SESSION" [field]="'ZoneName'" [headerName]="'Reports_Column_ZoneName' | translate" [sortable]="true" [tooltipField]="'ZoneName'" [hide]="true">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.SESSION" [field]="'StreamDevice'" [headerName]="'Reports_Column_Device' | translate" [sortable]="true" [tooltipField]="'StreamDevice'" [hide]="true">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.SESSION" [field]="'StreamAccessed'" [headerName]="'Reports_Column_PlaybackUrl' | translate" [sortable]="true" [tooltipField]="'StreamAccessed'" [hide]="true">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.SESSION" [field]="'IpAddress'" [headerName]="'IPAddress' | translate" [sortable]="true" [tooltipField]="'IpAddress'" [hide]="true">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.SYSTEM" [field]="'PlayerDevice'" [headerName]="'Reports_Attendees_Column_DeviceType' | translate" [sortable]="true" [tooltipField]="'PlayerDevice'" [hide]="true">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.SYSTEM" [field]="'Browser'" [headerName]="'Reports_Attendees_Column_Browser' | translate" [sortable]="true" [tooltipField]="'Browser'" [hide]="true">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.SYSTEM" [field]="'OsFamily'" [headerName]="'Reports_Attendees_Column_Platform' | translate" [sortable]="true" [tooltipField]="'OsFamily'" [hide]="true">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [cellRenderer]="'highlightText'" [columnPickerGroup]="ViewsColumnPickerGroup.SYSTEM" [field]="'OsName'" [headerName]="'Reports_Attendees_Column_PlatformVersion' | translate" [sortable]="true" [tooltipField]="'OsName'" [hide]="true">
		</vb-ui-data-grid-column>

	</vb-ui-infinite-scroll-grid>

</report-grid-wrapper>
